import {TakeFirstSchema} from '@yandex-delivery/form'
import {appConfig, i18n} from 'src/shared/config'
import {array, object, string} from 'yup'

import {OrderParcelSize} from '../Parcel/consts'

const ParcelSchema = object().shape({
  barcode: string().optional(),
  size: string()
    .oneOf([
      OrderParcelSize.ExtraExtraLarge,
      OrderParcelSize.ExtraLarge,
      OrderParcelSize.Large,
      OrderParcelSize.Medium,
      OrderParcelSize.Small,
      OrderParcelSize.ExtraSmall,
    ])
    .required(),
})

const PointSchema = object().shape({
  point: object().shape({
    id: string().required(),
  }),
})

const PointSchemaMobile = object().shape({
  _id: string().required(),
})

export const EstimateDeliverySchema = object({
  sourcePoint: object().shape({
    dropOffPoint: PointSchema,
  }),
  destinationPoints: array()
    .min(1)
    .concat(TakeFirstSchema) // в ndd возможен только один destination, поэтому берем только первый
    .of(
      object().shape({
        pickUpPoint: PointSchema,
        parcels: array().min(1).of(ParcelSchema),
        contact: object().shape({
          phone: string()
            .required()
            .test(
              'phone',
              i18n('validation.phone.invalid', 'Неверный формат телефона'),
              appConfig.checkIsValidPhone,
            ),
          name: string().required(),
        }),
      }),
    ),
  ndd: object().shape({
    deliveryDate: string().required(),
  }),
})

export const EstimateDeliverySchemaMobile = object({
  destinationPoints: array()
    .min(1)
    .concat(TakeFirstSchema)
    .of(
      object().shape({
        parcels: array().min(1).of(ParcelSchema),
      }),
    ),
  ndd: object().shape({
    deliveryDate: string().required(),
    route: object().shape({
      source: object().shape({
        pickupPoint: PointSchemaMobile,
        phone: string()
          .required()
          .test(
            'phone',
            i18n('validation.phone.invalid', 'Неверный формат телефона'),
            appConfig.checkIsValidPhone,
          ),
      }),
      destination: object().shape({
        pickupPoint: PointSchemaMobile,
        parcels: array().min(1).of(ParcelSchema),
        phone: string()
          .required()
          .test(
            'phone',
            i18n('validation.phone.invalid', 'Неверный формат телефона'),
            appConfig.checkIsValidPhone,
          ),
      }),
    }),
  }),
})
